import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
// swap to your asset path:
import loadingLottie from '../../assets/animations/loading-animation.lottie'; // or .lottie

/**
 * Fullscreen loading overlay.
 * Props:
 *  - open?: boolean (default true)
 *  - text?: string (default 'Loading…')
 *  - lottieSrc?: any (override animation)
 *  - backdropOpacity?: number 0..1 (default 0.35)
 */
export default function LoadingOverlay({
  open = true,
  text = "",
  lottieSrc = loadingLottie,
  backdropOpacity = 0.35,
}) {
  const [root, setRoot] = useState(null);

  useLayoutEffect(() => {
    // mount into a dedicated portal root so it's always on top
    let el = document.getElementById('overlay-root');
    if (!el) {
      el = document.createElement('div');
      el.id = 'overlay-root';
      document.body.appendChild(el);
    }
    setRoot(el);
  }, []);

  if (!open || !root) return null;

  const ui = (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `rgba(0,0,0,${backdropOpacity})`,
        zIndex: 9999,
        pointerEvents: 'auto',
      }}
    >
      <div
        style={{
          padding: '36px 40px',
          borderRadius: 20,
          background: 'var(--background, #0b0b0c)',
          color: '#fff',
          boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
          textAlign: 'center',
          minWidth: 440,
        }}
      >
        <DotLottieReact
          src={lottieSrc}
          autoplay
          loop
          style={{
            width: 320,
            height: 320,
            display: 'block',
            margin: '0 auto',
          }}
          onError={(e) => console.warn('Lottie failed to load', e)}
        />
        {text ? (
          <span
            style={{
              fontFamily: 'var(--font-family)',
              fontSize: '1.5rem',
              fontWeight: 400,
              display: 'block',
              marginTop: 18,
              color: 'var(--primary, #38bdf8)',
              textAlign: 'center',
            }}
          >
            {text}
          </span>
        ) : null}
      </div>
    </div>
  );

  return createPortal(ui, root);
}
